import { useAppSelector } from "../../index";

export const useEditedPersonalInfo = () => {
  return useAppSelector((state) => state.profile.editedPersonalInfo);
};

export const useEditingPersonalInfo = () => {
  return useAppSelector((state) => state.profile.editingPersonalInfo);
};
